export default __webpack_public_path__ + "static/media/login-image.10b45e31.jpg";